import { render, staticRenderFns } from "./main.menu.item.vue?vue&type=template&id=108b47af&scoped=true"
import script from "./main.menu.item.vue?vue&type=script&lang=js"
export * from "./main.menu.item.vue?vue&type=script&lang=js"
import style0 from "./main.menu.item.vue?vue&type=style&index=0&id=108b47af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b47af",
  null
  
)

export default component.exports